import type { PropType } from 'vue';
import { defineComponent, markRaw } from 'vue';
import { injectExoWebTemplates } from './legacy-template';
import type { AdminPageName } from './utils';
import { ensureCognitoGlobal } from './globals-management';

export default defineComponent({
	// Inherit attributes so that arbitrary attributes can be passed along as template data
	inheritAttrs: true,
	props: {
		templateName: {
			type: String as PropType<AdminPageName>,
			required: true
		},
		readyDependencies: {
			type: Array as PropType<string[]>,
			required: true
		},
		getTemplateData: {
			type: Function as PropType<(vm: any) => any>,
			default: null
		}
	},
	data: () => {
		return {
			isLoaded: false,
			loaded: null as (Promise<void> | true),
			isRendered: false,
			templateData: null,
			templateContext: null
		};
	},
	mounted() {
		if (!this.loaded)
			this.initializeLegacyTemplate();
	},
	methods: {
		initializeLegacyTemplate() {
			const Cognito = ensureCognitoGlobal();

			(Cognito as any).templateComponents.push(this);

			this.loaded = injectExoWebTemplates(this.templateName, this.$el as HTMLElement).then(() => { this.isLoaded = true; });

			// Activate the template once its ready dependencies are resolved
			Cognito.ready('MsAjaxTemplate-' + Date.now(), this.readyDependencies, () => {
				const templateData = this.getTemplateData ? this.getTemplateData(this) : this.$attrs;
				markRaw(templateData);
				const tc = (window.Sys as any).Application.activateElement(this.$el as HTMLElement, templateData, true, false, this);
				markRaw(tc);
				this.templateContext = tc;
				this.isRendered = true;
			});
		},
		disposeLegacyTemplate() {
			if (this.templateContext) {
				this.templateContext.dispose();
				this.templateContext = null;
			}
		},
		reset() {
			this.disposeLegacyTemplate();
			this.isLoaded = false;
			this.loaded = null;
			this.isRendered = false;
			this.templateData = null;
		},
		ensureLoaded() {
			if (!this.loaded)
				this.initializeLegacyTemplate();
			return this.loaded;
		}
	},
	render(createElement) {
		return createElement('div');
	}
});
